type ConsoleMethod = (...args: any[]) => void;

let applied = false;

export const appLogger = {
  debug: (..._args: any[]) => {},
  info: (..._args: any[]) => {},
  log: (..._args: any[]) => {},
  warn: (...args: any[]) => console.warn(...args),
  error: (...args: any[]) => console.error(...args),
};

/**
 * 앱 전역 콘솔 출력 최소화 정책
 * - log/info/debug 는 무음 처리
 * - warn/error 는 유지
 */
export function applyMinimalConsolePolicy(): void {
  if (applied || typeof window === 'undefined') return;
  applied = true;

  const c = console as unknown as Record<string, ConsoleMethod | undefined>;
  c.log = () => {};
  c.info = () => {};
  c.debug = () => {};
}

// 기존 호출부 호환용 alias
export const suppressVerboseConsoleLogs = applyMinimalConsolePolicy;